module.exports = __webpack_public_path__ + "static/assets/4cea14facc8e97adac5dc13503718d91.svg";